let broadcastChannel: BroadcastChannel | null = null

export const BROADCAST_TRIGGER = {
  SIGN_OUT: 'signout',
  GET_SESSION: 'getSession',
} as const

const getNewBroadcastChannel = () => {
  return new BroadcastChannel('auth')
}

export const broadcast = () => {
  if (typeof BroadcastChannel === 'undefined') {
    return {
      postMessage: () => {},
      addEventListener: () => {},
      removeEventListener: () => {},
    }
  }

  if (broadcastChannel === null) {
    broadcastChannel = getNewBroadcastChannel()
  }

  return broadcastChannel
}
